import type { Accessor } from 'solid-js'
import Input from '~/components/Input'
import TagInput from '~/components/TagInput'
import Textarea from '~/components/Textarea'

export interface GeneralTabPropsType {
  isService: Accessor<boolean>
}

/** Pestaña General: nombre, descripción, SKU y puntos destacados. */
function GeneralTab(props: GeneralTabPropsType) {
  const { isService } = props

  return (
    <div class="space-y-4">
      <Input name="name" label="Nombre" placeholder="New Balance 2002R Light Grey" />
      <Textarea name="description" label="Descripción" rows={5} placeholder="Qué es, para quién y qué problema resuelve" helperText="Es lo que el asesor de IA cuenta al visitante" />

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input name="sku" label="SKU" placeholder="NB-2002R-GY" />
        <Input name="barcode" label="Código de barras" placeholder="0924289012" />
      </div>

      <TagInput
        name="details"
        label={isService() ? 'Entregables' : 'Puntos destacados'}
        placeholder="Escribe uno y pulsa Enter"
        helperText={isService() ? 'El alcance del servicio, tal y como lo verá el cliente' : 'Lo que ayuda a decidir; las características medibles van en la ficha técnica'}
      />
    </div>
  )
}

export default GeneralTab
